// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".teacher-items-title[data-v-1d34ed46]{display:flex;align-items:center;justify-content:space-between}.teacher-items-title__name[data-v-1d34ed46]{width:100%;--tw-text-opacity:1;color:rgb(30 30 30 / var(--tw-text-opacity))}@media (min-width: 1024px){.teacher-items-title__name[data-v-1d34ed46]{width:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
